export const TRAVEL_DIRECTIONS = {
  TOWARDS: "to_airport",
  RETURN: "from_airport",
};

export const LHR_PLANNER_CONFIG = {
  airportCode: "LHR",
  airportName: "Heathrow Airport",
  airportDisplayName: "Heathrow",
  terminalPostcode: "TW6 1QG",
  defaultPickup: "W1A 1AA",
  defaultFlightNumberToAirport: "BA438",
  defaultFlightNumberFromAirport: "EI184",
  reviewsPageKey: "/leave-for-heathrow",
  secureJourneyMonitoring: true,
  api: {
    flightSuggest: "/api/heathrow/flights/suggest",
    flightLookup: "/api/heathrow/flights/lookup",
    outwardPlan: "/api/lhr/v1/flight-plan",
    returnPlan: "/api/lhr/v1/return/flight-plan",
    journeyByToken: (token) => `/api/lhr/v1/journey/${encodeURIComponent(token)}`,
    journeySendEmail: (token) => `/api/lhr/v1/journey/${encodeURIComponent(token)}/email`,
    journeyVerifyCode: (token) => `/api/lhr/v1/journey/${encodeURIComponent(token)}/verify-code`,
  },
};
